import React from 'react';
import { KeyedMutator } from 'swr';
import { ModalProps } from '../../../services/modals.service';
import { CleanUser } from '../../../export-types/cleaned-types';
import { useModalClose } from '../../../utils/useModalClose';
import { api } from '../../../services/api';
import { AlertService } from '../../../services/alert.service';

type SelfUnlinkObserverModalProps = ModalProps & {
  user: CleanUser;
  mutate?: KeyedMutator<any>;
};

export const SelfUnlinkObserverModal = ({
  user,
  close,
  mutate,
}: SelfUnlinkObserverModalProps) => {
  const modalRef = useModalClose(close);
  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    try {
      await api.post(`/user/${user.id}/observers/unlink`);
      AlertService.success();
      mutate?.();
      close();
    } catch (error: any) {
      AlertService.error(error?.message);
    }
  };
  return (
    <div className="modal-dialog mw-400" ref={modalRef}>
      <div className="modal-content">
        <div className="modal-header border-bottom-0 p-4">
          <button type="button" className="btn-close" onClick={close} />
        </div>
        <div className="modal-body pt-2 p-4 text-center">
          <h3 className="mb-4">Снять наблюдение?</h3>
          <form onSubmit={onSubmit}>
            <button type="submit" className="btn btn-success w-100 mb-3">
              Снять наблюдение
            </button>
            <button
              type="button"
              className="btn btn-light w-100"
              onClick={close}
            >
              Отменить
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
